export const RESTART_STATE = 'channelmap/basedatos/restart_state';
export const SET_MASK = 'channelmap/basedatos/set-mask';
export const UPDATE_FIELD_FILTER = 'channelmap/basedatos/update-field-filter';
